import React from 'react';
import { X } from 'lucide-react';

/**
 * Shared responsive shell for package-dimension modals (mobile / iPad / desktop).
 * `compact` = shorter chrome for view-only modals.
 */
const PackageDimensionModalShell = ({ title, onClose, children, footer, compact = false }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50 p-0 sm:p-4">
      <div
        className={`
          bg-white shadow-xl w-full
          max-h-[90vh] sm:max-h-[88vh]
          ${compact ? 'h-auto sm:max-w-2xl md:max-w-3xl lg:max-w-4xl' : 'h-[92vh] sm:h-auto sm:max-w-2xl md:max-w-3xl lg:max-w-4xl'}
          rounded-t-2xl sm:rounded-xl
          flex flex-col min-w-0 overflow-hidden
        `}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div
          className={`flex items-center justify-between gap-3 border-b border-gray-200 shrink-0 ${
            compact ? 'px-3 sm:px-4 py-2.5 sm:py-3' : 'px-4 sm:px-5 py-3 sm:py-4'
          }`}
        >
          <h2
            className={`font-semibold text-secondary min-w-0 truncate ${
              compact ? 'text-sm sm:text-base' : 'text-base sm:text-lg'
            }`}
          >
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-700 shrink-0"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div
          className={`flex-1 min-h-0 overflow-y-auto ${
            compact ? 'px-3 sm:px-4 py-3' : 'px-4 sm:px-5 py-3 sm:py-4'
          }`}
        >
          {children}
        </div>

        {footer && (
          <div
            className={`shrink-0 border-t border-gray-200 bg-white ${
              compact ? 'px-3 sm:px-4 py-2.5 sm:py-3' : 'px-4 sm:px-5 py-3 sm:py-4'
            }`}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default PackageDimensionModalShell;
